import React from 'react';
import { CalendarDays } from 'lucide-react';
import { useLeaveManagement } from '../leavemgmt/useLeaveManagement';
import { useLeaveDerived } from '../leavemgmt/useLeaveDerived';
import { useBulkHandlers } from '../leavemgmt/useBulkHandlers';
import { BulkModal as LeaveBulkModal } from '../leavemgmt/BulkModal';
import {
  actionRowStyle,
  badgeStyle,
  cardHeadStyle,
  cardStyle,
  cardSubStyle,
  cardTitleStyle,
  primaryButtonStyle,
} from './styles';

function getCompanyCode(company) {
  return String(company?.code || '').toUpperCase(); // 'PINE' 기본값 없음(2026-10-27) — 부르는 쪽이 늘 회사를 준다
}

// isHq: 이 회사가 이 사이트 본사인가(부모가 장부 기준으로 넘김 — 'PINE' 글자 판정 없앰 2026-10-27)
export default function LeaveBulkSetup({ company, isHq = false }) {
  const companyCode = getCompanyCode(company);
  const apiBase = isHq ? '/api/admin/leaves' : `/api/admin/ext/${companyCode}/leaves`;
  const settingsApiPath = isHq
    ? '/api/admin/attendance-time-settings'
    : `/api/admin/ext/${companyCode}/attendance-time-settings`;

  const state = useLeaveManagement({
    apiBase,
    syncLeavesEndpoint: isHq ? '/api/admin/sheets/sync/leaves' : '/api/admin/sheets/sync/external-leaves',
    settingsApiPath,
  });
  const derived = useLeaveDerived(state);
  const bulk = useBulkHandlers(state, derived, apiBase);

  return (
    <section style={cardStyle}>
      <div style={cardHeadStyle}>
        <h3 style={cardTitleStyle}>연차 초기 등록</h3>
        <span style={badgeStyle}>{companyCode}</span>
      </div>
      <p style={cardSubStyle}>연차 사용 내역을 여러 줄로 붙여넣어 등록합니다.</p>
      <div style={actionRowStyle}>
        <button style={primaryButtonStyle} onClick={() => state.setBulkOpen(true)}>
          <CalendarDays size={16} />
          연차 대량 추가
        </button>
      </div>
      <LeaveBulkModal
        bulkOpen={state.bulkOpen}
        closeBulkModal={bulk.closeBulkModal}
        bulkRows={state.bulkRows}
        bulkErrors={derived.bulkErrors}
        bulkNonEmptyCount={derived.bulkNonEmptyCount}
        bulkInvalidRowCount={derived.bulkInvalidRowCount}
        bulkSubmitting={state.bulkSubmitting}
        addBulkRows={bulk.addBulkRows}
        trimEmptyBulkRows={bulk.trimEmptyBulkRows}
        handleBulkCellChange={bulk.handleBulkCellChange}
        handleBulkCellPaste={bulk.handleBulkCellPaste}
        submitBulk={bulk.submitBulk}
      />
    </section>
  );
}
